import React from 'react';
import styled from 'styled-components';
import { DefaultTemplate } from 'components/templates';

const Wrapper = styled.div``;

const body = (
  <Wrapper>
    <h1>Page not found</h1>
  </Wrapper>
);

const NotFound = () => <DefaultTemplate body={body} />;

export default NotFound;
